/**
 * Helper functions for Directions Map component
 */

/**
 *
 * @param {*} colorCode
 */
const isColor = ( colorCode ) => {
  return /^#[0-9a-f]{6}$/i.test( colorCode.toString())
}

/**
 *
 * @param {*} value
 */
const toColor = ( value ) => {
  return '0x' + value.slice( 1 )
}

/**
 *
 * @param {*} jsonString
 */
const parse = ( jsonString ) => {
  let items = []
  let separator = '|'
  let json

  try {
    json = JSON.parse( jsonString )
  } catch ( error ) {
    return
  }

  for ( let i = 0; i < json.length; i++ ) {
    let item = json[i]
    let hasFeature = Object.prototype.hasOwnProperty.call( item, 'featureType' )
    let hasElement = Object.prototype.hasOwnProperty.call( item, 'elementType' )
    let stylers = item.stylers
    let target = ''
    let style = ''

    if ( !hasFeature && !hasElement ) {
      target = 'feature:all'
    } else {
      if ( hasFeature ) {
        target = 'feature:' + item.featureType
      }
      if ( hasElement ) {
        target = target ? target + separator : ''
        target += 'element:' + item.elementType
      }
    }

    for ( let s = 0; s < stylers.length; s++ ) {
      let styleItem = stylers[s]
      let key = Object.keys( styleItem )[0] // there is only one per element
      style = style ? style + separator : ''
      style += key + ':' + ( isColor( styleItem[key]) ? toColor( styleItem[key]) : styleItem[key])
    }

    items.push( target + separator + style )
  }

  return '&style=' + items.join( '&style=' )
}

const staticMapParser = {
  parse: parse,
  isColor: isColor,
  toColor: toColor
}
export default staticMapParser
